import React, { useEffect, useRef, useState } from "react";
import {
  baseWrapperStyle,
  toastStyle,
  spinnerStyle,
  messageStyle,
} from "./styles";

const DownloadToast = ({ downloading }) => {
  const [visible, setVisible] = useState(false);
  const [fadingOut, setFadingOut] = useState(false);
  const [message, setMessage] = useState("");
  const prevIsDownloading = useRef(downloading.isDownloading);
  const [viewport, setViewport] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    const handleResize = () => {
      setViewport({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const { width, height } = viewport;

  const isDesktop = width >= 1024;
  const isLandscape = !isDesktop && width > height;
  const isPortrait = !isDesktop && height >= width;

  useEffect(() => {
    let timeout;

    const started = downloading.isDownloading && !prevIsDownloading.current;
    const finished = !downloading.isDownloading && prevIsDownloading.current;

    if (started) {
      const tipo =
        downloading.type === "media" ? "arquivo de mídia" : "planilha";

      setMessage(`Baixando ${tipo}...`);
      setVisible(true);
      setFadingOut(false);
    }

    if (finished) {
      setMessage("Download concluído!");
      setFadingOut(true);

      const fadeDuration = 600;
      const delay = 800;

      timeout = setTimeout(() => {
        setVisible(false);
        setFadingOut(false);
      }, fadeDuration + delay);
    }

    prevIsDownloading.current = downloading.isDownloading;

    // cleanup
    return () => {
      if (timeout) clearTimeout(timeout);
    };
  }, [downloading.isDownloading, downloading.type]);

  if (!visible) return null;

  const wrapperStyle = { ...baseWrapperStyle };

  if (isDesktop) {
    Object.assign(wrapperStyle, {
      top: 24,
      left: "50%",
      transform: "translateX(-50%)",
      width: "80%",
      maxWidth: 720,
      justifyContent: "center",
    });
  } else if (isLandscape) {
    Object.assign(wrapperStyle, {
      bottom: 24,
      left: 16,
      right: 16,
      justifyContent: "center",
    });
  } else if (isPortrait) {
    Object.assign(wrapperStyle, {
      top: 40,
      left: 16,
      right: 16,
      justifyContent: "center",
    });
  }

  const finalToastStyle = {
    ...toastStyle,
    opacity: fadingOut ? 0 : 1,
  };

  const showSpinner = downloading.isDownloading && !fadingOut;

  return (
    <div style={wrapperStyle}>
      <div style={finalToastStyle}>
        {showSpinner && <div style={spinnerStyle} />}
        <span style={messageStyle}>{message}</span>
      </div>
    </div>
  );
};

export default DownloadToast;
